<style lang="scss">
    @import "../style/config.scss";
    .DatePicker {
        &.is-single {
            .el-input__inner::placeholder {
                font-weight: bold;
                color: #333;
            }
        }
    }
</style>
<template>
    <span class="DatePicker" :class="{'is-single': single}">
        <slot>
            <span>{{ single ? '日期筛选：' : '时间筛选：' }}</span>
        </slot>
        <template v-if="single">
            <el-date-picker v-model="date" type="date" placeholder="全部" clearable :value-format="format" :size="size" :picker-options="pickerOptions" style="width:140px;" @change="SingleChange()" />
        </template>
        <template v-else>
        <el-date-picker v-model="start" type="date" placeholder="选择日期" :value-format="format" :size="size" style="width:140px;" @change="StartChange()" />
        <span style="padding:0 2px;">至</span>
        <el-date-picker v-model="end" type="date" placeholder="选择日期" :value-format="format" :size="size" style="width:140px;" @change="EndChange()" />
        </template>
    </span>
</template>

<script>
export default {
    name: 'DatePicker',
    data() {
        return {
            start: null,
            end: null,
            date: null
        }
    },
    props: {
        value: {},
        single: {
            type: Boolean,
            default: false
        },
        size: {
            default: 'small'
        },
        format: {
            default: 'yyyy-MM-dd'
        }
    },
    watch: {
        value(val) {
            this.Input()
        }
    },
    computed: {
        pickerOptions() {
            return {
                disabledDate: (time) => {
                    const today = new Date()
                    today.setHours(0, 0, 0, 0)
                    return time.getTime() > today.getTime()
                }
            }
        }
    },
    methods: {
        init() {
            this.Input()
        },
        Input() {
            if (this.single) {
                if (this.value && this.value[0]) {
                    this.$set(this, 'date', this.Time(this.value[0], this.format))
                } else {
                    this.$set(this, 'date', null)
                }
                return
            }
            if (this.value) {
                if (this.value[0] && this.value[1]) {
                    this.$set(this, 'start', this.Time(this.value[0], this.format))
                    this.$set(this, 'end', this.value[1])
                } else if (this.value[0]) {
                    this.$set(this, 'start', this.value[0])
                    this.$set(this, 'end', this.value[0])
                } else if (this.value[1]) {
                    this.$set(this, 'start', this.value[1])
                    this.$set(this, 'end', this.value[1])
                }
            }
        },
        SingleChange() {
            if (!this.date) {
                this.$emit('input', null)
                this.$emit('change', null)
                return
            }
            const interval = [`${this.date} 00:00:00`, `${this.date} 23:59:59`]
            this.$emit('input', interval)
            this.$emit('change', interval)
        },
        StartChange() {
            if (this.start >= this.end) {
                this.$set(this, 'end', this.start)
            }
            this.$emit('input', [this.start, this.end])
            this.$emit('change', [this.start, this.end])
        },
        EndChange() {
            if (this.start >= this.end) {
                this.$set(this, 'start', this.end)
            }
            this.$emit('input', [this.start, this.end])
            this.$emit('change', [this.start, this.end])
        }
    },
    mounted() {
        this.init()
    }
}
</script>